"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientRecognitionLogin = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var login_1 = require("../../model/login");
var service_1 = require("../../../library/base/service");
var ClientRecognitionLogin = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ClientRecognitionLogin, _super);
    function ClientRecognitionLogin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '人脸指纹识别登录接口';
        _this.code = '101079';
        _this.desc = '人脸指纹识别登录接口';
        _this.requestParams = new login_1.ClientRecognitionLoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return ClientRecognitionLogin;
}(service_1.BaseService));
exports.ClientRecognitionLogin = ClientRecognitionLogin;
//# sourceMappingURL=clientRecognitionLogin.js.map